//请自行添加语言资源
import item from "../../orderImport/lang/orderImport.en";

const orderSearch = {
  projectCode: '项目编号',
  projectName: '项目名称',
  originAddrCode: '发货地址编码',
  originAddrName: '发货方名称',
  originAddrContactMan: '发货人',
  originAddrContactTel: '发货人联系方式',
  originAddrProvinceName: '发货省份',
  originAddrCityName: '发货城市',
  originAddrDistrictName: '发货区/县',
  sendStreet: '发货街道',
  originAddrLocation: '发货地址',
  originAddrLongitude: '发货X坐标',
  originAddrLatitude: '发货y坐标',

  destAddrCode: '收货地址编码',
  destAddrName: '收货方名称',
  destAddrContactMan: '收货人',
  destAddrContactTel: '收货人联系方式',
  destAddrProvinceName: '收货省份',
  destAddrCityName: '收货城市',
  destAddrDistrictName: '收货区/县',
  receiveStreet: '收货街道',
  destAddrLocation: '收货地址',
  destAddrLatitude: '收货y坐标',
  destAddrLongitude: '收货X坐标',

  transTypeName: '运输方式',
  totalVolume: '总体积(M3)',
  shipperCode: '货主编号',
  orderType: '订单类型',
  createTime: '创建时间',
  totalQty: '总箱数',
  orderClassify: '订单分类',
  reqDispatchDate: '要求发货时间',
  companyName: '机构名称',
  soOrSto: '客户相关单号',
  shipperName: '货主名称',
  totalNetWeight: '总净重(KG)',
  orderStatusName: '订单状态',
  orderNo: 'TMS单号',
  totalWeight: '总毛重(KG)',
  updater: '更新者',
  customerOrderNo: '客户订单号',
  updateTime: '更新时间',
  waybillNo: '面单号',
  companyCode: '机构编号',
  carrierName: '承运商名称',
  orderStatusNo: '订单状态',
  creator: '创建者',
  transTypeNo: '运输方式',
  orderDate: '订单日期',
  orderSource: '订单来源',
  reqArriverDate: '要求送达时间',
  carrierNo: '承运商编号',
  urgentFlag: '是否加急',
  basic: {
    shipperName: '货主',
    companyName: '所属机构',
    customerOrderNo: '客户订单号',
    soOrSto: '客户相关单号',
    orderDate: '订单日期',
    reqDispatchDate: '要求发货日期',
    reqArriverDate: '要求到货日期',
    originAddrName: '发货方',
    originAddrLocation: '发货方地址',
    originAddrCityName: '发货方城市',
    destAddrName: '收货方',
    destAddrLocation: '收货方地址',
    destAddrCityName: '收货方城市',
    destAddrContactMan: '收货方联系人',
    destAddrContactTel: '收货方联系电话',
    planNo: '运输计划单号',
    outPlanNo: '外部计划单号',
    orderProperty: '订单属性',
    gpsFetchSource: 'GPS采用渠道',
  },
  detail: {
    skuName: '产品名称',
    skuLotno: '批次',
    qty: '订单数量',
    sendQty: '实发数量',
    receiveQty: '实收数量',
    totalWeight: '重量(Kg)',
    totalVolume: '体积(m³)',
    totalNetWeight: '净重'
  },
  transport: {
    planNo: '运输计划单号',
    carrierName: '承运商名称',
    truckNo: '车牌号',
    truckTypeName: '车型',
    driverName: '司机姓名',
    driverTel: '司机电话',
  }
};
export default orderSearch



// WEBPACK FOOTER //
// ./src/page/order/orderSearch/lang/orderSearch.zh.js